import { IBrandingProvider } from "./IBrandingProvider";
import { DexterityBranding } from "./providers/DexterityBranding";
import { GTBranding } from "./providers/GTBranding";

const brandingRegistry: Record<string, IBrandingProvider> = {
  "GT": new GTBranding(),
  "default": new DexterityBranding()
};

export function getBranding(client: string): IBrandingProvider {
  return brandingRegistry[client] || brandingRegistry["default"];
}
